import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {
  RulesLinks,
  DiscontTerms,
} from '../../../../constants/other-links.const';
import { AnalyticsEventsService } from '../../../../services/analytic.service';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.sass'],
})
export class RulesComponent implements OnInit {
  public brand: string;
  public rulesList: any;
  public discontTerms: any;

  constructor(public analyticService: AnalyticsEventsService) {}

  ngOnInit(): void {
    this.brand = environment.brand;
    this.rulesList = RulesLinks[this.brand];
    this.discontTerms = DiscontTerms[this.brand];
  }
}
